import OpenInFullRoundedIcon from '@mui/icons-material/OpenInFullRounded';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ChartRequest } from 'app-components/flux/ai-chat/aiChatTypes';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import ChartPreview from './ChartPreview';

const useStyles = makeStyles({ name: 'ChatMessageChartCard' })((theme) => ({
  root: {
    marginLeft: theme.spacing(5),
    marginTop: theme.spacing(1.5),
  },
  chartBubble: {
    flex: 1,
    minWidth: 0,
    padding: theme.spacing(1.5),
  },
  chartHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
  },
}));

type ChatMessageChartCardProps = {
  chart: ChartRequest;
  onExpand: (chart: ChartRequest) => void;
};

const ChatMessageChartCard = ({ chart, onExpand }: ChatMessageChartCardProps): React.JSX.Element => {
  const { classes } = useStyles();
  const title = chart.title || 'Chart preview';

  return (
    <Box className={classes.root}>
      <Paper className={classes.chartBubble}>
        <Box className={classes.chartHeader}>
          <Stack sx={{ minWidth: 0, flex: 1 }}>
            <Typography variant='bodyMedium' noWrap title={title}>
              {title}
            </Typography>
            {chart.description ? (
              <Typography variant='captionRegular' color='textSecondary'>
                {chart.description}
              </Typography>
            ) : null}
          </Stack>
          <IconButton size='small' variant='tonal' aria-label='Expand chart' onClick={() => onExpand(chart)}>
            <OpenInFullRoundedIcon fontSize='small' />
          </IconButton>
        </Box>

        <Box sx={{ marginTop: 1, width: '100%', minWidth: 0 }}>
          <ChartPreview chart={chart} />
        </Box>
      </Paper>
    </Box>
  );
};

export default ChatMessageChartCard;
